"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FlexLayout = _interopRequireDefault(require("../Layouts/FlexLayout"));

var _TextLabel = _interopRequireDefault(require("../Typography/TextLabel"));

var _CloseIcon = _interopRequireDefault(require("../Icons/CloseIcon"));

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * This is a private component that is used to highlight which items are selected in
 * MultiSelectInput
 */
var MultiSelectedItemTag =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MultiSelectedItemTag, _React$Component);

  function MultiSelectedItemTag() {
    var _getPrototypeOf2;

    var _temp, _this;

    _classCallCheck(this, MultiSelectedItemTag);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MultiSelectedItemTag)).call.apply(_getPrototypeOf2, [this].concat(args))), _this.handleOnClose = function () {
      var _this$props = _this.props,
          onClose = _this$props.onClose,
          id = _this$props.id;

      if (onClose) {
        onClose(id);
      }
    }, _temp));
  }

  _createClass(MultiSelectedItemTag, [{
    key: "render",
    value: function render() {
      // eslint-disable-next-line no-unused-vars
      var _this$props2 = this.props,
          className = _this$props2.className,
          onClose = _this$props2.onClose,
          disabled = _this$props2.disabled,
          children = _this$props2.children,
          props = _objectWithoutProperties(_this$props2, ["className", "onClose", "disabled", "children"]);

      var styleProps = {
        'data-disabled': disabled
      };
      var textLabelType = disabled ? _TextLabel.default.TEXT_LABEL_TYPE.INFO : _TextLabel.default.TEXT_LABEL_TYPE.PRIMARY;
      return _react.default.createElement(_FlexLayout.default, _extends({
        className: (0, _classnames.default)(className, "".concat(_ThemeManager.default.getVar('classPrefix'), "-multi-selected-item-tag")),
        alignItems: "center",
        itemSpacing: "5px",
        padding: "5px",
        display: "inline-flex"
      }, styleProps, props), _react.default.createElement(_TextLabel.default, {
        type: textLabelType
      }, children), disabled ? null : _react.default.createElement(_CloseIcon.default, {
        onClick: this.handleOnClose,
        size: "small"
      }));
    }
  }]);

  return MultiSelectedItemTag;
}(_react.default.Component);

exports.default = MultiSelectedItemTag;
MultiSelectedItemTag.defaultProps = {
  disabled: false
};
MultiSelectedItemTag.propTypes = {
  className: _propTypes.default.string,

  /**
   * Unique string/num identifier for this item.
   * See onClose.
   */
  id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * Callback for when close icon is clicked.
   * onClose(id)
   * {string | number} id: See props.id above.
   */
  onClose: _propTypes.default.func,

  /**
   * This is the title of the SelectedItem.
   */
  children: _propTypes.default.string.isRequired,

  /**
   * disabled style.  When true close icon won't be shown.
   */
  disabled: _propTypes.default.bool
};